<template>
  <div v-if="adminCanModifyItem || adminCanModifyBooking">
    <b-card class="admin-options d-inline-block" body-class="py-0">
      <strong class="text-danger">
        {{ trans('admin_options') }}:
      </strong>
      <b-button
        v-if="adminCanModifyItem"
        variant="link"
        class="text-danger"
        @click="onClickModifyItems"
        :title="trans('microsite_modify_invoice_items')"
        v-b-tooltip.hover
      >
        <i class="fa fa-fw fa-edit"></i>
        {{ trans('items') }}
      </b-button>
      <b-button
        v-if="adminCanModifyBooking"
        variant="link"
        class="text-danger"
        @click="onClickModifyBookings"
        :title="trans('microsite_modify_bookings')"
        v-b-tooltip.hover
      >
        <i class="fa fa-fw fa-edit"></i>
        {{ trans('booking') }}
      </b-button>
    </b-card>
    <admin-bookings-modal
      :id="id + '-bookings-modal'"
      :organization="organization"
      :bookings="bookings"
      :busy="busy"
      @update="$emit('update', $event)"
    ></admin-bookings-modal>
    <admin-invoice-items-modal
      :id="id + '-items-modal'"
      :organization="organization"
      :invoice_items="invoice_items"
      @invoice="$emit('invoice', $event)"
    ></admin-invoice-items-modal>
  </div>
</template>

<script>
  import AdminBookingsModal from './AdminBookingsModal'
  import AdminInvoiceItemsModal from './AdminInvoiceItemsModal'

  export default {
    props: {
      id: {
        type: String,
        default: 'admin-modify',
      },
      organization: Object,
      invoice_items: Array,
      bookings: Array,
      busy: Boolean,
    },
    components: {
      AdminBookingsModal,
      AdminInvoiceItemsModal,
    },
    data() {
      return {
        trans: trans,
      }
    },
    computed: {
      adminCanModifyBooking() {
        return this.organization.auth_user &&
          this.organization.auth_user.microsite_permissions.can_modify_bookings &&
          this.bookings.length > 0
      },
      adminCanModifyItem() {
        return this.organization.auth_user &&
          this.organization.auth_user.microsite_permissions.can_modify_items &&
          this.invoice_items.length > 0
      },
    },
    methods: {
      onClickModifyItems() {
        this.$bvModal.show(this.id + '-items-modal')
      },
      onClickModifyBookings() {
        this.$bvModal.show(this.id + '-bookings-modal')
      },
    },
    mounted() {
      window.adminModifyItems = this
    },
  }
</script>